<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>Handbook of Reason</span></p>
<p class="authorname"><span>Dagobert D. Runes</span></p>
<p class="publisher"><span><img alt="image" class="svg" src="images/fig_02.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?62f15128